import * as React from "react";
import type { SVGProps } from "react";
const SvgWind02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m2.4 17.94 2.389-.832a7.6 7.6 0 0 1 6.364.63 7.6 7.6 0 0 0 6.459.596l3.988-1.45m-19.2-4.68 2.389-.834a7.6 7.6 0 0 1 6.364.63 7.6 7.6 0 0 0 6.459.596l3.988-1.45M2.4 6.465l2.389-.834a7.6 7.6 0 0 1 6.364.63 7.6 7.6 0 0 0 6.459.596l3.988-1.45"
    />
  </svg>
);
export default SvgWind02;
